export const PerfeedService = {
    getFeedbacks,
    getRequests,
    getRequestSettings,
    saveRequestSettings,
};

function getFeedbacks() {
    return true;
}

function getRequests() {
    return true;
}

function getRequestSettings() {
    return true;
}

function saveRequestSettings() {
    return true;
}
